import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { HrRoutingModule } from './hr-routing.module';
import { HrDetailsLinkComponent } from './hr-details-link/hr-details-link.component';
import { ManpowerRequisitionFormComponent } from './manpower-requisition-form/manpower-requisition-form.component';
import { MrfUser2Component } from './mrf-user2/mrf-user2.component';
import { EmployeeGrevienceModule } from '../modules/employee-grevience/employee-grevience.module';
import { AcademicFormModule } from '../modules/academic-form/academic-form.module';
import { SideBarComponent } from './side-bar/side-bar.component';
import { HrAlertService, HrHttpService } from './hr-http.service';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AgGridModule } from 'ag-grid-angular';
import { MrfDashboardComponent } from './mrf-dashboard/mrf-dashboard.component';
import { MrfHrFormComponent } from './mrf-hr-form/mrf-hr-form.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { MrfFilterDialogComponent } from './mrf-filter-dialog/mrf-filter-dialog.component';
import { MrfPrincipalDeanComponent } from './mrf-principal-dean/mrf-principal-dean.component';
import { MrfConfirmAlertComponent } from './mrf-confirm-alert/mrf-confirm-alert.component';
import { BudgetDetailsFormComponent } from './budget-details-form/budget-details-form.component';
import { BudgetReportComponent } from './budget-report/budget-report.component';
import { MrfBudgetReportComponent } from './mrf-budget-report/mrf-budget-report.component';
import { EmployeeWithdrawalComponent } from './employee-withdrawal/employee-withdrawal.component';
import { MrfHttpInterceptor } from './mrf-http.interceptor';
@NgModule({
  declarations: [
    HrDetailsLinkComponent,
    ManpowerRequisitionFormComponent,
    MrfUser2Component,
    SideBarComponent,
    MrfDashboardComponent,
    MrfHrFormComponent,
    MrfFilterDialogComponent,
    MrfPrincipalDeanComponent,
    MrfConfirmAlertComponent,
    BudgetDetailsFormComponent,
    BudgetReportComponent,
    MrfBudgetReportComponent,
    EmployeeWithdrawalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HrRoutingModule,
    EmployeeGrevienceModule,
    AcademicFormModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    AgGridModule,
  ],
  providers: [
    HrHttpService,
    HrAlertService,
    NgDialogAnimationService,
    { provide: HTTP_INTERCEPTORS, useClass: MrfHttpInterceptor, multi: true },
  ],
})
export class HrModule { }
